window.IdealCustomOptions = (function () {

  let currentRequest = null;
  let currentItem = null;
  const preloadQueue = [];
  const loadedSet = new Set();

  function loadCustomOptions(itemEl) {
    return new Promise((resolve, reject) => {
      const $item = $(itemEl);
      const productid = $item.data('productid');
      const variantid = $item.data('variantid');
      const product_handle = $item.data('producthandle');

      const url = `/?section_id=ic-ajax-custom-options&product=${productid}&variant=${variantid}&product_handle=${product_handle}&_=${Date.now()}`;

      if (loadedSet.has(productid)) {
        resolve();
        return;
      }

      if (currentRequest) {
        currentRequest.abort();
        currentRequest = null;
      }

      currentItem = productid;

      currentRequest = $.ajax({
        url,
        method: 'GET'
      })
        .done(html => {
          renderOptions(itemEl, html);
          loadedSet.add(productid);
          resolve();
        })
        .fail((xhr, status) => {
          if (status !== 'abort') {
            reject(status);
          }
        })
        .always(() => {
          currentRequest = null;
          currentItem = null;
          runPreloadQueue();
        });
    });
  }

  function runPreloadQueue() {
    if (currentRequest) return;
    if (preloadQueue.length === 0) return;

    const nextItem = preloadQueue.shift();
    loadCustomOptions(nextItem).catch(() => {});
  }

  function renderOptions(itemEl, html) {
    const $section = $(html);
    $(itemEl).find('.option-container').html($section.html());


    const _product_select_hinged =$('.js-select-hinged', itemEl);
    const _product_select_hinged_option =$('.js-select-hinged option', itemEl);
    const _product_select_plywood_upgrade =$('.js-option-item-plywood-upgrade select', itemEl);
    const _product_select_plywood_upgrade_option =$('.js-option-item-plywood-upgrade select option', itemEl);   

    add_view_custom_options_events(_product_select_hinged, _product_select_hinged_option, _product_select_plywood_upgrade, _product_select_plywood_upgrade_option);

   
    $('.side-popover',$(itemEl)).popover().mouseover(function(e){
          $('.product-modal-wrap .side-popover[aria-describedby]').not(this).popover('hide');
          if($(this).hasClass('side-popover')){
            if($('#'+ $(this).attr('aria-describedby')).length == 0){                
                $(this).popover('show');
              }
          }
    });
  }
  /* async function preloadAll() {
    const items = $('.js-view-custom-options');

    for (const el of items) {
      await loadCustomOptions(el);
      await new Promise(r => setTimeout(r, 300));
    }
  }

  $(function () {  
      preloadAll();
  }); */


  function add_view_custom_options_events(_product_select_hinged, _product_select_hinged_option, _product_select_plywood_upgrade, _product_select_plywood_upgrade_option){
      _product_select_hinged_option.each(function(){
            const $this = $(this);
            const product_id = $this.attr('data-id');
            const product_handle = $this.attr('data-p-handle');
            const variant_id = $this.attr('data-v-id');
          
            const plywood_no_side_variant_id = $this.attr('data-plywood-v-no-side-id');
            const plywood_no_side_add_price = $this.attr('data-plywood-no-side-add-price');


            const ew_no_side_variant_id = $this.attr('data-ew-v-no-side-id');
            const ew_no_side_price = $this.attr('data-ew-v-no-side-price');
            const ew_left_side_variant_id = $this.attr('data-ew-v-left-side-id');
            const ew_right_side_variant_id = $this.attr('data-ew-v-right-side-id');
            const ew_both_side_variant_id = $this.attr('data-ew-v-both-side-id');
    
            const ew_left_side_add_price = $this.attr('data-ew-left-add-price');
            const ew_right_side_add_price = $this.attr('data-ew-right-add-price');
            const ew_both_side_add_price = $this.attr('data-ew-both-add-price');
        
            const depth_min = $this.attr('data-min-depth');
            const depth_max = $this.attr('data-max-depth');
            const depth_default = $this.attr('data-default-depth');

            const optional_add_ones = $this.attr('data-optional-add-ones');
            const optional_add_ones_split_item = $this.attr('data-optional-add-ones-split-item');
            const optional_add_ones_split_child = $this.attr('data-optional-add-ones-split-child');

            $this.data('obj',{
              'product_id': product_id,          
              'product_handle': product_handle,
              'variant_id':variant_id,
              'depth':{
                'min': depth_min,
                'max': depth_max,
                'default': depth_default,
              },
              'ew':{
                'no_side':{
                  'variant_id':ew_no_side_variant_id,
                  'price':ew_no_side_price,
                },
                'left_side':{
                  'variant_id':ew_left_side_variant_id,
                  'add_price':ew_left_side_add_price
                },
                'right_side':{
                  'variant_id':ew_right_side_variant_id,
                  'add_price':ew_right_side_add_price
                },
                'both_side':{
                  'variant_id':ew_both_side_variant_id,
                  'add_price':ew_both_side_add_price
                },
                'optional':{
                  'add_ones':optional_add_ones,
                  'split_item':optional_add_ones_split_item,
                  'split_child':optional_add_ones_split_child
                }
              },
              'plywood':{
                'no_side':{
                  'variant_id':plywood_no_side_variant_id,
                  'add_price':plywood_no_side_add_price
                },          
              }
            });

            $this.removeAttr('data-id')
              .removeAttr('data-p-handle')
              .removeAttr('data-v-id')
              .removeAttr('data-plywood-v-no-side-id')
              .removeAttr('data-plywood-no-side-add-price')        
              .removeAttr('data-ew-v-no-side-id')
              .removeAttr('data-ew-v-no-side-price')
              .removeAttr('data-ew-v-left-side-id')
              .removeAttr('data-ew-v-right-side-id')
              .removeAttr('data-ew-v-both-side-id')
              .removeAttr('data-ew-left-add-price')
              .removeAttr('data-ew-right-add-price')
              .removeAttr('data-ew-both-add-price')
              .removeAttr('data-min-depth')
              .removeAttr('data-max-depth')
              .removeAttr('data-default-depth')
              .removeAttr('data-optional-add-ones')
              .removeAttr('data-optional-add-ones-split-item')
              .removeAttr('data-optional-add-ones-split-child');

      });

      _product_select_plywood_upgrade_option.each(function(){
            const $this = $(this);
            const id = $this.attr('data-id');

            if($this.val()==='No'){
              const no_side_price = $this.attr('data-price');    
              const left_side_id = $this.attr('data-left-side-id');    
              const right_side_id = $this.attr('data-right-side-id');
              const both_side_id = $this.attr('data-both-side-id');
              const left_side_add_price = $this.attr('data-left-side-add-price');
              const right_side_add_price = $this.attr('data-right-side-add-price');
              const both_side_add_price = $this.attr('data-both-side-add-price');
              const optional_add_ones = $this.attr('data-optional-add-ones');
              const optional_add_ones_split_item = $this.attr('data-optional-add-ones-split-item');
              const optional_add_ones_split_child = $this.attr('data-optional-add-ones-split-child');
                    
              $this.data('obj',{
                'type' : 'EW',
                'no_side' :{
                  id,
                  'price':no_side_price,
                },
                'left_side':{
                  'id' : left_side_id,
                  'add_price' : left_side_add_price,
                },
                'right_side':{
                  'id' : right_side_id,
                  'add_price' : right_side_add_price,
                },
                'both_side':{
                  'id' : both_side_id,
                  'add_price' : both_side_add_price,
                },
                'optional':{
                  'add_ones' : optional_add_ones,
                  'split_item' : optional_add_ones_split_item,
                  'split_child' : optional_add_ones_split_child,
                },
              });

              $this.removeAttr('data-left-side-id')
              .removeAttr('data-right-side-id')
              .removeAttr('data-both-side-id')
              .removeAttr('data-left-side-add-price')
              .removeAttr('data-right-side-add-price')
              .removeAttr('data-both-side-add-price')
              .removeAttr('data-optional-add-ones')
              .removeAttr('data-optional-add-ones-split-item')
              .removeAttr('data-optional-add-ones-split-child');
            }else{
              $this.data('obj',{
                'type' : 'Plywood',
                'no_side' :{
                  id,
                },            
              });
            }       
            $this.removeAttr('data-id');
      });

      _product_select_hinged.change(function(){
            const data = $(this).find('option:selected').data('obj');
            //console.log(data);
            const container = $(this).closest('.option-container');
            
            const the_add_to_cart_button = container.closest('.js-product-item').find('.js-add-to-cart-button');
            const the_add_to_cart_data = the_add_to_cart_button.data('obj').split(':');
            let the_new_add_to_cart_data = the_add_to_cart_data
              .map((handle, index) => 
                {
                  if (index === 2) return data.product_handle;
                  if (index === 0) return data.product_id;
                  return handle;
                })
              .join(':');
            the_add_to_cart_button.data('obj',the_new_add_to_cart_data); 
    
            const plywood_upgrade_div = $('.js-option-item-plywood-upgrade',container);       
            const depth_div = $('.js-option-item-depth',container);
            
          
          

            if(!isNaN(parseInt(data.depth.max)) &&
              !isNaN(parseInt(data.depth.min)) &&
              !isNaN(parseInt(data.depth.default))){
                const selected_depth_value = depth_div.is(':visible')? depth_div.find('select option:selected').val() : '';
                depth_div.find('select').empty();
                for(let i = parseInt(data.depth.min); i<= parseInt(data.depth.max); i++){
                    const option_text = i == parseInt(data.depth.default)
                        ? `None (${i}" is standard)`
                        : `${i}" Depth&nbsp;+$0.00`;
                    const option = $(`<option value="${i}">${option_text}</option>`);
                    depth_div.find('select').append(option);
                }

                let set_depth_value = data.depth.default;
                if(depth_div.find(`select option[value="${selected_depth_value}"]`).length == 1){
                    set_depth_value = selected_depth_value;
                }         
                depth_div.find('select').val(set_depth_value).trigger('change');

          }else{
            depth_div.hide();
            depth_div.find('select').empty();
          }
          

          
          

            if(data.plywood.no_side.variant_id != '0'){
              const selected_plywood_upgrade_value = plywood_upgrade_div.is(':visible')? plywood_upgrade_div.find('select option:selected').val() : '';
              plywood_upgrade_div.find('select').empty().append(`<option value="No" >No (sides will be white)</option><option value="Yes" >Yes +${(data.plywood.no_side.add_price??"")}</option>`);
              if(selected_plywood_upgrade_value == 'Yes' || selected_plywood_upgrade_value == 'No'){       
                
                plywood_upgrade_div.find(`select option[value="Yes"]`).data('obj',{
                  'type' : 'Plywood',
                  'no_side':{
                    'id': data.plywood.no_side.variant_id,
                  },
                });
                plywood_upgrade_div.find(`select option[value="No"]`).data('obj',{
                'type' : 'EW',
                'no_side':{
                    'id': data.ew.no_side.variant_id,
                    'price': data.ew.no_side.price,
                },
                'left_side':{
                  'id' : data.ew.left_side.variant_id,
                  'add_price' : data.ew.left_side.add_price,
                },
                'right_side':{
                  'id' :  data.ew.right_side.variant_id,
                  'add_price' : data.ew.right_side.add_price,
                },
                'both_side':{
                  'id' :  data.ew.both_side.variant_id,
                  'add_price' : data.ew.both_side.add_price,
                },
                'optional':{
                  'add_ones' : data.ew.optional.add_ones,
                  'split_item' : data.ew.optional.split_item,
                  'split_child' : data.ew.optional.split_child,
                },
              });
                

                //plywood_upgrade_div.find('select option:selected').prop('selected', false);
                //plywood_upgrade_div.find(`select option[value="${selected_plywood_upgrade_value}"]`).prop('selected', true);
                if(selected_plywood_upgrade_value.length > 0){
                  plywood_upgrade_div.find('select').val(selected_plywood_upgrade_value).trigger('change');
                }else{
                  plywood_upgrade_div.find('select').val('No').trigger('change');
                }
              }
              plywood_upgrade_div.show();

            }else{          
              plywood_upgrade_div.hide();
              plywood_upgrade_div.find('select').empty();
              const add_to_cart_button = container.closest('.js-product-item').find('.js-add-to-cart-button');
              const add_to_cart_data = add_to_cart_button.data('obj').split(':');
              let new_add_to_cart_data = add_to_cart_data
                .map((item, index) => index === 1 ? data.variant_id : item)
                .join(':');
              add_to_cart_button.data('obj',new_add_to_cart_data);          
            }
            
        });

      _product_select_plywood_upgrade.change(function(){
            const $this = $(this);
            const current_selected_value = $this.val();
            const current_selected_data = $this.find('option:selected').data('obj');
            //console.log(current_selected_data);
            const container = $(this).closest('.option-container');
            

            const add_to_cart_button = container.closest('.js-product-item').find('.js-add-to-cart-button');
            const add_to_cart_data = add_to_cart_button.data('obj').split(':');
            let new_add_to_cart_data = add_to_cart_data
              .map((item, index) => index === 1 ? current_selected_data.no_side.id : item)
              .join(':');     
                    
            add_to_cart_button.data('obj',new_add_to_cart_data);   

      });

      
  }

  async function loadCustomOptionsByAddToCart(_start_add_to_cart_button_selector, icon_img_src, side_img_src){  
    const itemEl = $(_start_add_to_cart_button_selector).closest('.js-product-item').find('.js-view-custom-options')[0];
    const productid = $(itemEl).data('productid');
    if (loadedSet.has(productid)) return;       
    Show_Loading("Loading..."); 
    await loadCustomOptions(itemEl);  
    Hide_Loading();
  }

  $(document).on('show.bs.collapse', '.js-view-custom-options-panel', function () {
    const itemEl = $(this).closest('.js-view-custom-options')[0];
    const productid = $(itemEl).data('productid');

    if (loadedSet.has(productid)) return;

    const i = preloadQueue.indexOf(itemEl);
    if (i > -1) preloadQueue.splice(i, 1);
    loadCustomOptions(itemEl).catch(() => {});
  });

  function show_ew_side_modal(data, add_to_cart_button, icon_img_src, side_img_src){



          let side_item_html = ``; 
          if(data.no_side.id != '0'){
            side_item_html += `<label class="radio-item">
                                    <input type="radio" name="side" checked="checked" value="No" data-id="${data.no_side.id}"  />
                                    No finished sides needed
                                </label>`;                              
          }
          if(data.left_side.id != '0'){
            side_item_html += `<label class="radio-item">
                                    <input type="radio" name="side" value="Left" data-id="${data.left_side.id}" />
                                    <span>Add matching finished side - Left <span class="text_gray">(+${data.left_side.add_price})</span></span>
                              </label>`;                              
          }
          if(data.right_side.id != '0'){
            side_item_html += `<label class="radio-item">
                                    <input type="radio" name="side" value="Right" data-id="${data.right_side.id}" />
                                    <span>Add matching finished side - Right <span class="text_gray">(+${data.right_side.add_price})</span></span>
                              </label>`;                              
          }
          if(data.both_side.id != '0'){
            side_item_html += `<label class="radio-item">
                                    <input type="radio" name="side" value="Both" data-id="${data.both_side.id}" />
                                    <span>Add matching finished sides - Both <span class="text_gray">(+${data.both_side.add_price})</span></span>
                              </label>`;                              
          }
        
          var obj = `<div class="modal-side modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                          <div class="modal-dialog" role="document">
                              <div class="modal-content">
                                  <div class="modal-header">
                                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">X</button>
                                  </div>
                                  <div class="modal-body">
                                      <h2>Let's review your finished side options</h2>
                                      <p class="subtitle">
                                          Matching finished sides are factory-installed and color-matched to ensure a
                                          clean, professional finish with no additional install steps.
                                      </p>

                                      <h3>
                                          Factory-Installed Finished Sides*
                                          <a
                                            style="margin-left: 1rem;"
                                            rel="popover"
                                            data-html="true"
                                            data-content="<div class='producthint'><h4 style='font-size: 2rem; color: #000; text-align: left; width: calc(100% - 120px);'><strong>Matching Finished Sides</strong></h4><div class='side_content'><div style='width: 50%;'>
                                                        <p>Matching finished sides are optional, factory-installed panels used on any cabinet end that will be visible in your design for a clean, color-matched look.</p>
                                                        <p>(Decorative end panels are available separately if you want a furniture-style look.)</p>
                                                      </div>
                                                      <div style='position: relative;'>
                                                      <small style='position: absolute; bottom: -2rem; right: 0; font-size: 1.2rem;'><i>*Shown in Newport Mythic Blue</i></small>
                                                      <img loading='lazy' class='img-responsive' width='250' height='283' src='https://cdn.shopify.com/s/files/1/0788/2060/6243/files/A1B3DACEB270B93F8AE67C2A92917187.png?v=1765438900' /></div>
                                                  </div>"
                                            data-placement="bottom"
                                            data-toggle="popover"
                                            data-trigger="hover"
                                            onclick="return false;"
                                            aria-label="Side help"                              
                                            href="#"
                                            >
                                              <img class="img-responsive" alt="" src="${icon_img_src}" rel=""
                                                  width="20" height="20" loading="lazy" style="display:inline-block;">
                                          </a>
                                      </h3>

                                      <div class="radio-group">
                                          <img loading="lazy" class="img-responsive img-product" alt=""
                                              src="${side_img_src}" width="250" height="250">
                                          <div>
                                            ${side_item_html}
                                          </div>
                                      </div>
                                      <div class="add-ones"></div>
                                    
                                      <button class="btn btn_outline_oranage js-save-and-continue" style="width: 100%;">Save &amp; Continue</button>
                                  </div>
                              </div>
                          </div>
                      </div>`;
          obj = $(obj);
          obj.data('obj',data);
          if(data?.optional?.add_ones?.length){


            const add_ones = $(`<div> 
                                      <hr />
                                      <h3>Optional finish &amp; trim add-ons</h3>
                                      <div class="checkbox-group"></div>
                                  </div>`);
            

          
            const add_ones_array = data.optional.add_ones.split(data.optional.split_item);
            


            for(let i=0;i< add_ones_array.length;i++){
              const item_array = add_ones_array[i].split(data.optional.split_child);
              const item_attribute = item_array[0];
              const item_title = formatAttribute(item_array[1]);
              const item_desc = formatAttribute(item_array[2]);
              const item_productid = formatAttribute(item_array[3]);
              const item_variantid = formatAttribute(item_array[4]);
              const item_price = formatAttribute(item_array[5]);
              

              const item_obj = $(`<label class="checkbox-item">
                                      <input type="checkbox" >
                                              <div style="line-height: 1.5;">
                                                  <strong>Add ${item_title}</strong>&nbsp;<span class="text_gray">(+${item_price})</span>
                                                  <p>${item_desc}</p>
                                              </div>
                                  </label>`);
            item_obj.find(':checkbox').data('obj',item_attribute);
            item_obj.appendTo(add_ones.find('.checkbox-group'));

            }
            obj.find('.add-ones').append(add_ones);
          }

          obj.find('.radio-item :radio').each(function(){
            $(this).data('obj',$(this).attr('data-id')).removeAttr('data-id');
          });


        obj.find('.js-save-and-continue').bind('click',function(){
            const container = $(this).closest('.modal-side');
            const selected_option = container.find('.radio-item > input:radio:checked');
            if(selected_option.length == 0 ){
              alert('Please select side.');
              return;
            }

            const selected_add_ones = container.find('.checkbox-item > input:checkbox:checked');

            let add_ones_data = [];
            selected_add_ones.each(function(){
              const iten_attribute = $(this).data('obj');
              add_ones_data.push({
                'quantity' : 1,
                'attribute' : iten_attribute
              });
            });    

            const select_side_variant_id = selected_option.data('obj');     
            const add_to_cart_data = add_to_cart_button.data('obj').split(':');
            const new_add_to_cart_data = add_to_cart_data
              .map((item, index) => index === 1 ? select_side_variant_id : item)
              .join(':');
            add_to_cart_button.data('obj',new_add_to_cart_data);    
            add_to_cart_button.data('add_ones',add_ones_data); 
            add_to_cart_button.data('side_modal',obj);  
            
            add_to_cart_button.data('side_submit',true);  

            add_to_cart_button.trigger('click');


        });

          obj.on('show.bs.modal', async function () {
              $('.js-save-and-continue').focus();
              $('[data-toggle="popover"]', obj).popover();
          })
          .on("hidden.bs.modal", function() {          
            $(this).remove();        
          })
          .modal('show');
  };


  function add_side_event_collection(_start_add_to_cart_button_selector, icon_img_src, side_img_src){
        _start_add_to_cart_button_selector.click(async function(ev){         

          await loadCustomOptionsByAddToCart($(this), icon_img_src, side_img_src);   

          const add_to_cart_button = $(this).closest('.js-product-item').find('.js-add-to-cart-button');

          add_to_cart_button.data('add_ones',null);    
          const container = $(this).closest('.js-product-item').find('.option-container');
          
          if(container.length > 0  && (container.find('.js-option-item-plywood-upgrade select option:selected').data('obj')?.type??'') === 'EW')
          {  
              const data = container.find('.js-option-item-plywood-upgrade select option:selected').data('obj');
              //console.log(data);
              //alert('EW');
              if((data?.left_side?.id??'0') != '0' ||
                (data?.right_side?.id??'0')  != '0'  ||
                (data?.both_side?.id??'0')  != '0'){
              
                  show_ew_side_modal(data, add_to_cart_button, icon_img_src, side_img_src);
                  return;
              }           
          }
          
          add_to_cart_button.trigger('click');
        });
  }


  function add_side_event(_start_add_to_cart_button_selector, _product_select_hinged, _product_select_hinged_option, _product_select_plywood_upgrade, _product_select_plywood_upgrade_option, icon_img_src, side_img_src){
        _start_add_to_cart_button_selector.click(async function(ev){       
          const add_to_cart_button = $(this).closest('.js-product-item').find('.js-add-to-cart-button');

          add_to_cart_button.data('add_ones',null);    
          const container = $(this).closest('.js-product-item').find('.option-container');
          if(container.length > 0 && (container.find('.js-option-item-plywood-upgrade select option:selected').data('obj')?.type??'') === 'EW')
          {  
              const data = container.find('.js-option-item-plywood-upgrade select option:selected').data('obj');
              //console.log(data);
              //alert('EW');
              if((data?.left_side?.id??'0') != '0' ||
                (data?.right_side?.id??'0')  != '0'  ||
                (data?.both_side?.id??'0')  != '0'){
              
                  show_ew_side_modal(data, add_to_cart_button, icon_img_src, side_img_src);
                  return;
              }           
          }
          
          add_to_cart_button.trigger('click');
        });

        add_view_custom_options_events(_product_select_hinged, _product_select_hinged_option, _product_select_plywood_upgrade, _product_select_plywood_upgrade_option);
  };


 return {
    add_side_event_collection,
    add_side_event,
    show_ew_side_modal
  };

})();
